export default{
    async requestOnetimePassOffice(){
        let result = null;
        await this.$axios.$get(
            this.$api.user.onetimePass.office,
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
        })
        return result;
    },

    async requestOnetimePassHome(){
        let result = null;
        await this.$axios.$get(
            this.$api.user.onetimePass.home,
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
        })
        return result;
    },

    async getOnetimePassAvailable(){
        return await this.$axios.$get(
            this.$api.user.onetimePass.isAvailable
        )
    },
}